import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/react";
import { ProfileProps } from "types";
import { SolIcon } from "@solstice/sol-react";
import { useApiCall } from "hooks";
import { copyProfileAPI } from "services";
import { Dispatch } from "react";

type CopyProfileProps = {
  profiles: ProfileProps[] | null;
  selectedProfileId: ProfileProps["id"] | undefined;
  setSelectedProfile: Dispatch<ProfileProps | null>;
};

const CopyProfile: React.FC<CopyProfileProps> = ({
  profiles,
  selectedProfileId,
  setSelectedProfile,
}) => {
  const [copyProfile, loading] = useApiCall(copyProfileAPI);

  if (!profiles || profiles.length < 2) {
    return null;
  }
  if (!selectedProfileId) {
    return null;
  }
  const remainingProfiles = profiles.filter(
    (profile) => profile.id !== selectedProfileId
  );

  const handleCopyProfile = async (sourceProfileId: ProfileProps["id"]) => {
    try {
      const res = await copyProfile({
        source_profile_id: sourceProfileId,
        target_profile_id: selectedProfileId,
      });
      // use the response to update the selected profile.
      // probably a more robust way would be to invalidate all the states and refetch: broker and profiles
      setSelectedProfile(res);
    } catch (error) {
      console.error("Error copying profile:", error);
    }
  };
  return (
    <div className="">
      <Menu>
        {({ open }) => (
          <>
            <MenuButton className="inline-flex items-center gap-2 rounded-md px-3 py-1.5 w-96 text-jll-text-base-subdued-6 border border-jll-stroke-default-1 hover:bg-jll-surface-base-secondary-alpha-1 hover:bg-opacity-5 focus:not-data-focus:outline-none data-focus:outline data-focus:outline-white">
              {loading ? (
                <SolIcon icon="cached" className="animate-spin" />
              ) : (
                <SolIcon icon="copy_all" />
              )}
              Copy From Another Country Profile
              <SolIcon
                icon="chevron_right"
                className="rotate-90 fill-jll-text-base-subdued-6 ml-auto"
              />
            </MenuButton>
            {open && (
              <MenuItems
                transition
                anchor="bottom end"
                className="mt-2 origin-top-right z-10 rounded-md w-96 border border-white/5 bg-white shadow-xl p-1 text-sm/6 transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0"
              >
                {remainingProfiles.map((profile) => (
                  <MenuItem key={profile.id}>
                    <button
                      className="group flex w-full items-center justify-between rounded py-1 px-3 text-jll-text-base-subdued-6 hover:bg-jll-stroke-interaction hover:bg-opacity-10"
                      onClick={() => {
                        handleCopyProfile(profile.id);
                      }}
                    >
                      {profile?.country?.name} ({profile?.language_name})
                      <SolIcon icon="arrow_right_alt" />
                    </button>
                  </MenuItem>
                ))}
              </MenuItems>
            )}
          </>
        )}
      </Menu>
    </div>
  );
};

export default CopyProfile;
